import React from 'react';

import SignUpPage from '../registration/SignUpPage';

/**
 * The /signUp url is used externally so we may need to adjust behavior over time.
 * 
 * Note: The referrer data is handled by the RegistrationProvider 
 */
const SignUpController = () => {
  return <SignUpPage />
}

export default SignUpController;